export enum NAMES {
  PAGE_TITLE = 'Геостатистика - Национальный статистический комитет Республики Беларусь',
  TO_MAIN = 'На главную',
  MAIN_TITLE = 'Национальный статистический комитет Республики Беларусь',
  FEEDBACK = ' Обратная связь',
  LOG_IN = 'Войти',
  LANG_RUS = 'РУС',
  LANG_BEL = 'БЕЛ',
  LANG_ENG = 'ENG',
  SUBSTRATE_LAYER = 'Подложка',
  ZOOM_TO_LAYER = 'Приблизить к объекту',
  EXPORT_MODAL_TITLE = 'Экспорт данных',
  EXPORT_MAP_TITLE = 'Экспорт карты',
  INFO = 'Информация',
  ATE = 'ATE',
  LEGEND = 'Легенда',
  PARAM_NAME = 'Наименование параметра',
  SEARCH = 'Поиск...',
  YOUR_NAME = 'Ваше имя',
  YOUR_MAIL = 'Ваш e-mail',
  YOUR_MESSAGE = 'Текст сообщения',
  FEEDBACK_CONFIRM_DEFAULT = 'Я ознакомлен и согласен на ',
  FEEDBACK_CONFIRM_SPAN = 'обработку персональных данных',
  FEEDBACK_CONFIRMED = 'Согласен на обработку персональных данных',
  FEEDBACK_WARNING_TEXT = 'Для отправки сообщения необходимо дать согласие на обработку персональных данных',
  SEND = 'Отправить',
  CANCEL = 'Отмена',
  FEEDBACK_INFO_TITLE = 'Условия обработки персональных данных',
  ZOOM_IN_TL = 'Увеличить масштаб',
  ZOOM_OUT_TL = 'Уменьшить масштаб',
  SUBSTRATE_TL = 'Выбор подложки',
  RULER_TL = 'Линейка',
  EXTENT_TL = 'Экстент по умолчанию',
  FULLSCREEN_TL = 'Развернуть на весь экран',
  SCALE_BAR_TL = 'Масштабная линейка',
  SEARCH_TYPE_LAYERS = 'Поиск по слоям',
  SEARCH_TYPE_BE = 'Поиск по субъектам хозяйствования',
  LIST_LEGAL_FORM_TITLE = 'Организационно-правовая форма',
  EMPTY_STATISTICS_DATA = 'По выбранным параметрам данные отсутствуют, выберите более крупный (высокий) уровень административно-территориального деления',
}

export const localizedTexts = {
  ru: {
    COOKIE_NOTIFICATION_TEXT:
      'Мы используем файлы cookie, чтобы улучшить ваш опыт на сайте. Нажимая "Принять", вы соглашаетесь с использованием файлов cookie.',
    NOTIFICATION_BTN: 'Принять',
    PAGE_TITLE:
      'Геостатистика - Национальный статистический комитет Республики Беларусь',
    COOKIE_NOTIFICATION_BTN: 'Принять',
    COOKIE_NOTIFICATION_BTN_REJECT: 'Отменить',
    COOKIE_NOTIFICATION_BTN_CHANGE: 'Изменить',
    COOKIE_NOTIFICATION_EXTEND_TITLE: 'Расширенные настройки cookie файлов',
    COOKIE_EXTEND_NECESSARY: 'Обязательные',
    COOKIE_EXTEND_ANALITYCS: 'Аналитика',
    COOKIE_EXTEND_MARKETING: 'Маркетинг',
    TO_MAIN: 'На главную',
    MAIN_TITLE: 'Национальный статистический комитет Республики Беларусь',
    FEEDBACK: 'Обратная связь',
    AUTH: 'Авторизация',
    LOG_IN: 'Войти',
    LOG_OUT: 'Выйти',
    LANG_RUS: 'РУС',
    LANG_BEL: 'БЕЛ',
    LANG_ENG: 'ENG',
    SUBSTRATE_LAYER: 'Подложка',
    ZOOM_TO_LAYER: 'Приблизить к объекту',
    EXPORT_MODAL_TITLE: 'Экспорт данных',
    EXPORT_MAP_TITLE: 'Экспорт карты',
    INFO: 'Информация',
    ATE: 'ATE',
    LEGEND: 'Легенда',
    PARAM_NAME: 'Выбор слоя',
    SEARCH: 'Поиск...',
    YOUR_NAME: 'Ваше имя',
    YOUR_MAIL: 'Ваш e-mail',
    YOUR_MESSAGE: 'Текст сообщения',
    FEEDBACK_CONFIRM_DEFAULT: 'Я ознакомлен и согласен на',
    FEEDBACK_CONFIRM_SPAN: 'обработку персональных данных',
    FEEDBACK_CONFIRMED: 'Согласен на обработку персональных данных',
    FEEDBACK_WARNING_TEXT:
      'Для отправки сообщения необходимо дать согласие на обработку персональных данных',
    SEND: 'Отправить',
    CANCEL: 'Отмена',
    FEEDBACK_INFO_TITLE: 'Условия обработки персональных данных',
    ZOOM_IN_TL: 'Увеличить масштаб',
    ZOOM_OUT_TL: 'Уменьшить масштаб',
    SUBSTRATE_TL: 'Выбор подложки',
    RULER_TL: 'Линейка',
    EXTENT_TL: 'Экстент по умолчанию',
    FULLSCREEN_TL: 'Развернуть на весь экран',
    SCALE_BAR_TL: 'Масштабная линейка',
    LOGIN: 'Логин',
    PASSWORD: 'Пароль',
    WRONG_DATA: 'Неверный логин или пароль',
    LOG_BTN: 'Войти',
    SHORT_PASS: 'Длина пароля не менее 8 символов',
    NEED_LOGIN_PASS: 'Необходимо ввести логин и пароль',
    NEED_FILL_FIELDS: 'Необходимо заполнить все поля',
    LOG_OUT_CONFIRM: 'Вы действительно хотите выйти ?',
    YES: 'ДА',
    NO: 'Нет',
    SEARCH_TYPE_LAYERS: 'Поиск по слоям',
    SEARCH_TYPE_BE: 'Поиск предприятий в бизнес-демографии',
    LIST_LEGAL_FORM_TITLE: 'Организационно-правовая форма',
    LIST_ACTIVITY_TITLE: 'Вид экономической деятельности',
    LAYERS_TL: 'Слои',
    TABLES_TL: 'Таблицы',
    PIE_TAB_TL: 'Круговая диаграмма',
    DIAGRAMS_TL: 'Гистограмма',
    SEARCH_TL: 'Поиск',
    EMPTY_SUBSTRATE: 'Без подложки',
    BUILD: 'Построить',
    DATASET_SELECT: 'Набор данных',
    LAYER_SELECT: 'Выбор слоя',
    ATE_REGIONS: 'Области',
    ATE_CITIES: 'Районы, города областного подчинения, районные центры',
    ATE_CITIES_SEARCH: 'Районы, города областного подчинения',
    ATE_VC: 'Сельсоветы и населенные пункты',
    START_MEASURE_TL: 'Нажмите для начала измерений',
    CONTINUE_MEASURE_TL: 'Нажмите для продолжения измерения длины',
    SELECT_ALL: 'Все',
    BUSINESS_SEARCH_DIS_TL: 'Необходимо выбрать все параметры поиска',
    LAYER_NAME: 'слой',
    MAP_NAME: 'Карта',
    EXPORT_CURRENT_EXTENT: 'Экспорт текущего экстента',
    EXPORT_ALL_LAYER: 'Экспорт всего слоя',
    LOGIN_TL: 'Логин пользователя:',
    LOGIN_TL_LANG:
      '• должен состоять из букв латинского алфавита (английская раскладка клавиатуры)',
    LOGIN_TL_DIGITS: '• не может содержать более 2 (двух) цифр',
    LOGIN_TL_SYMBOLSl: '• может содержать элементы пунктуации из списка «@, _»',
    PASSWORD_TL: 'Требования к паролю пользователя:',
    PASSWORD_TL_LENGTH: '• длина пароля не менее 8 символов',
    PASSWORD_TL_LETTERS: '• обязательное использование в пароле букв и цифр',
    PASSWORD_TL_REG:
      '• хотя бы одна из букв пароля должна быть в верхнем регистре',
    REQUIRED_FEEDBACK_EMAIL: 'Необходимо заполнить',
    WRONG_FEEDBACK_EMAIL: 'Некорректный email',
    YEAR: 'Год',
    WRONG_STATISTICS:
      'Используйте другой тип визуализации (гистограммы, таблицы)',
    DIS_STAT_CITIES_TL: 'Необходимо выбрать не более одной области',
    DIS_STAT_VC_TL: 'Необходимо выбрать не более одного района',
    DIS_STAT_LAYER_TL: 'Необходимо выбрать несколько объектов АТЕ',
    UNIT_NAME: 'Единица измерения',
    DYNAMIC_SERIES: 'Динамический ряд',
    METADATA: 'Метаданные',
    EMPTY_STATISTICS_DATA:
      'По выбранным параметрам данные отсутствуют, выберите более крупный (высокий) уровень административно-территориального деления',
  },
  en: {
    NOTIFICATION_TEXT:
      '  We use cookies to improve your experience on the website. By clicking "Accept," you agree to the use of cookies.',
    NOTIFICATION_BTN: 'Accept',
    PAGE_TITLE:
      ' Geostatistics - National Statistical Committee of the Republic of Belarus',
    COOKIE_NOTIFICATION_TEXT:
      'We use cookies to improve your experience on the website. By clicking "Accept," you agree to the use of cookies.',
    COOKIE_NOTIFICATION_BTN: 'Accept',
    COOKIE_NOTIFICATION_BTN_REJECT: 'Cancel',
    COOKIE_NOTIFICATION_BTN_CHANGE: 'Change',
    COOKIE_NOTIFICATION_EXTEND_TITLE: 'Advanced cookie settings',
    COOKIE_EXTEND_NECESSARY: 'Necessary',
    COOKIE_EXTEND_ANALITYCS: 'Analitycs',
    COOKIE_EXTEND_MARKETING: 'Marketing',
    TO_MAIN: 'To Main',
    MAIN_TITLE: 'National Statistical Committee of the Republic of Belarus',
    FEEDBACK: 'Feedback',
    AUTH: 'Authorization',
    LOG_IN: 'Log In',
    LOG_OUT: 'Log Out',
    LANG_RUS: 'RUS',
    LANG_BEL: 'BEL',
    LANG_ENG: 'ENG',
    SUBSTRATE_LAYER: 'Basemap',
    ZOOM_TO_LAYER: 'Zoom to Object',
    EXPORT_MODAL_TITLE: 'Export Data',
    EXPORT_MAP_TITLE: 'Export Map',
    INFO: 'Information',
    ATE: 'ATE',
    LEGEND: 'Legend',
    PARAM_NAME: 'Select Layer',
    SEARCH: 'Search...',
    YOUR_NAME: 'Your Name',
    YOUR_MAIL: 'Your e-mail',
    YOUR_MESSAGE: 'Message Text',
    FEEDBACK_CONFIRM_DEFAULT: 'I have read and agree to',
    FEEDBACK_CONFIRM_SPAN: 'the processing of personal data',
    FEEDBACK_CONFIRMED: 'I agree to the processing of personal data',
    FEEDBACK_WARNING_TEXT:
      'To send the message, you need to give consent to the processing of personal data',
    SEND: 'Send',
    CANCEL: 'Cancel',
    FEEDBACK_INFO_TITLE: 'Personal Data Processing Policy',
    ZOOM_IN_TL: 'Zoom In',
    ZOOM_OUT_TL: 'Zoom Out',
    SUBSTRATE_TL: 'Basemap Selection',
    RULER_TL: 'Ruler',
    EXTENT_TL: 'Default Extent',
    FULLSCREEN_TL: 'Expand to Fullscreen',
    SCALE_BAR_TL: 'Scale Bar',
    LOGIN: 'Login',
    PASSWORD: 'Password',
    WRONG_DATA: 'Incorrect login or password',
    LOG_BTN: 'Log In',
    SHORT_PASS: 'Password length should be at least 8 characters',
    NEED_LOGIN_PASS: 'Login and password are required',
    NEED_FILL_FIELDS: 'All fields are required',
    LOG_OUT_CONFIRM: 'Do you really want to leave ?',
    YES: 'YES',
    NO: 'NO',
    SEARCH_TYPE_LAYERS: 'Search by layers',
    SEARCH_TYPE_BE: 'Search for enterprises in business demography',
    LIST_LEGAL_FORM_TITLE: 'Legal Form',
    LIST_ACTIVITY_TITLE: 'Type of economic activity',
    LAYERS_TL: 'Layers',
    TABLES_TL: 'Tables',
    PIE_TAB_TL: 'Pie Chart',
    DIAGRAMS_TL: 'Histogram',
    SEARCH_TL: 'Search',
    EMPTY_SUBSTRATE: 'No basemap',
    BUILD: 'Build',
    DATASET_SELECT: 'Dataset',
    LAYER_SELECT: 'Layer selection',
    ATE_REGIONS: 'Regions',
    ATE_CITIES: 'Districts, cities of regional subordination, district centers',
    ATE_CITIES_SEARCH: 'Districts, cities of regional subordination',
    ATE_VC: 'Village councils and settlements',
    START_MEASURE_TL: 'Click to start measuring',
    CONTINUE_MEASURE_TL: 'Press to continue length measurement',
    SELECT_ALL: 'All',
    BUSINESS_SEARCH_DIS_TL: 'You must select all search options',
    LAYER_NAME: 'layer',
    MAP_NAME: 'Map',
    EXPORT_ALL_LAYER: 'Export entire layer',
    EXPORT_CURRENT_EXTENT: 'Export current extent',
    LOGIN_TL: 'User login:',
    LOGIN_TL_LANG:
      '• must consist of letters of the Latin alphabet (English keyboard layout)',
    LOGIN_TL_DIGITS: '• cannot contain more than 2 (two) digits',
    LOGIN_TL_SYMBOLSl:
      '• may contain punctuation elements from the list "@, _"',
    PASSWORD_TL: 'User password requirements:',
    PASSWORD_TL_LENGTH: '• password length is at least 8 characters',
    PASSWORD_TL_LETTERS:
      '• mandatory use of letters and numbers in the password',
    PASSWORD_TL_REG:
      '• at least one of the password letters must be in uppercase',
    REQUIRED_FEEDBACK_EMAIL: 'Required to be filled in',
    WRONG_FEEDBACK_EMAIL: 'Invalid email',
    YEAR: 'Year',
    WRONG_STATISTICS: 'Use a different visualization type (histograms, tables)',
    DIS_STAT_CITIES_TL: 'At most one area must be selected',
    DIS_STAT_VC_TL: 'At most one district must be selected',
    DIS_STAT_LAYER_TL: 'Multiple ATE objects must be selected',
    UNIT_NAME: 'Unit of measure',
    DYNAMIC_SERIES: 'Dynamic Series',
    METADATA: 'Metadata',
    EMPTY_STATISTICS_DATA:
      'No data are available for the selected parameters, select the larger (higher) level of administrative-territorial division',
  },
  by: {
    COOKIE_NOTIFICATION_TEXT:
      'Мы выкарыстоўваем кукі-файлы для паляпшэння вашага досведу на сайце. Прыціскаючы "Прыняць", вы згаджаецеся з выкарыстаннем кукі-файлаў.',
    COOKIE_NOTIFICATION_BTN: 'Прыняць',
    COOKIE_NOTIFICATION_BTN_REJECT: 'Адмяніць',
    COOKIE_NOTIFICATION_BTN_CHANGE: 'Змяніць',
    COOKIE_NOTIFICATION_EXTEND_TITLE: 'Пашыраныя налады cookie файлаў',
    COOKIE_EXTEND_NECESSARY: 'Неабходны',
    COOKIE_EXTEND_ANALITYCS: 'Аналітыка',
    COOKIE_EXTEND_MARKETING: 'Маркетынг',
    TO_MAIN: 'На галоўную',
    PAGE_TITLE:
      'Геастатыстыка - Нацыянальны статыстычны камітэт Рэспублікі Беларусь',
    MAIN_TITLE: 'Нацыянальны статыстычны камітэт Рэспублікі Беларусь',
    FEEDBACK: 'Зваротная сувязь',
    AUTH: 'Аўтарызацыя',
    LOG_IN: 'Увайсці',
    LOG_OUT: 'Выйсці',
    LANG_RUS: 'РУС',
    LANG_BEL: 'БЕЛ',
    LANG_ENG: 'ENG',
    SUBSTRATE_LAYER: 'Падложка',
    ZOOM_TO_LAYER: "Наблізіць да аб'екту",
    EXPORT_MODAL_TITLE: 'Экспарт даных',
    EXPORT_MAP_TITLE: 'Экспарт карты',
    INFO: 'Інфармацыя',
    ATE: 'ATE',
    LEGEND: 'Легенда',
    PARAM_NAME: 'Выбар слоя',
    SEARCH: 'Пошук...',
    YOUR_NAME: 'Ваша імя',
    YOUR_MAIL: 'Ваш e-mail',
    YOUR_MESSAGE: 'Тэкст паведамлення',
    FEEDBACK_CONFIRM_DEFAULT: 'Я знайшоў і згодны на',
    FEEDBACK_CONFIRM_SPAN: 'абработку персанальных дадзеных',
    FEEDBACK_CONFIRMED: 'Згодны на апрацоўку персанальных дадзеных',
    FEEDBACK_WARNING_TEXT:
      'Для дасылання паведамлення неабходна дасць згоду на апрацоўку персанальных дадзеных',
    SEND: 'Даслаць',
    CANCEL: 'Адмяніць',
    FEEDBACK_INFO_TITLE: 'Умовы апрацоўкі персанальных дадзеных',
    ZOOM_IN_TL: 'Павялічыць маштаб',
    ZOOM_OUT_TL: 'Паменшыць маштаб',
    SUBSTRATE_TL: 'Выбар падложкі',
    RULER_TL: 'Лінейка',
    EXTENT_TL: 'Экстэнт па змаўчаннi',
    FULLSCREEN_TL: 'Разгарнуць на поўны экран',
    SCALE_BAR_TL: 'Маштабная лінейка',
    LOGIN: 'Лагін',
    PASSWORD: 'Пароль',
    WRONG_DATA: 'Няправільны лагін або пароль',
    LOG_BTN: 'Увайсці',
    SHORT_PASS: 'Даўжыня пароля не менш за 8 знакаў',
    NEED_LOGIN_PASS: 'Неабходна ўвесці лагін і пароль',
    NEED_FILL_FIELDS: 'Неабходна запоўніць усе палі',
    LOG_OUT_CONFIRM: 'Вы сапраўды хочаце выйсці ?',
    YES: 'ДА',
    NO: 'Не',
    SEARCH_TYPE_LAYERS: 'Пошук па слаях',
    SEARCH_TYPE_BE: 'Пошук прадпрыемстваў у бізнес-дэмаграфіі',
    LIST_LEGAL_FORM_TITLE: 'Арганізацыйна-прававая форма',
    LIST_ACTIVITY_TITLE: 'Вiд эканамічнай дзейнасці',
    LAYERS_TL: 'Слаi',
    TABLES_TL: 'Табліцы',
    PIE_TAB_TL: 'Кругавая дыяграма',
    DIAGRAMS_TL: 'Гістаграма',
    SEARCH_TL: 'Пошук',
    EMPTY_SUBSTRATE: 'Без падложкі',
    BUILD: 'Пабудаваць',
    DATASET_SELECT: 'Набор даных',
    LAYER_SELECT: 'Выбар слоя',
    ATE_REGIONS: 'Вобласці',
    ATE_CITIES: 'Раёны, гарады абласнога падпарадкавання, раённыя цэнтры',
    ATE_CITIES_SEARCH: 'Раёны, гарады абласнога падпарадкавання',
    ATE_VC: 'Сельсаветы і населеныя пункты',
    START_MEASURE_TL: 'Націсніце для пачатку вымярэнняў',
    CONTINUE_MEASURE_TL: 'Націсніце для працягу вымярэння даўжыні',
    SELECT_ALL: 'Усе',
    BUSINESS_SEARCH_DIS_TL: 'Неабходна выбраць усе параметры пошуку',
    LAYER_NAME: 'слой',
    MAP_NAME: 'Карта',
    EXPORT_ALL_LAYER: 'Экспарт усяго слоя',
    EXPORT_CURRENT_EXTENT: 'Экспарт бягучага экстэнту',
    LOGIN_TL: 'Лагін карыстальніка:',
    LOGIN_TL_LANG:
      '• павінен складацца з літар лацінскага алфавіту (ангельская раскладка клавіятуры)',
    LOGIN_TL_DIGITS: '• не можа змяшчаць больш за 2 (двух) лічбаў',
    LOGIN_TL_SYMBOLSl: '• можа змяшчаць элементы пунктуацыі са спісу «@, _»',
    PASSWORD_TL: 'Патрабаванні да пароля карыстальніка:',
    PASSWORD_TL_LENGTH: '• даўжыня пароля не менш за 8 сімвалаў',
    PASSWORD_TL_LETTERS: '• абавязковае выкарыстанне ў паролі літар і лічбаў',
    PASSWORD_TL_REG:
      '• хаця б адна з літар пароля павінна быць у верхнім рэгістры',
    REQUIRED_FEEDBACK_EMAIL: 'Неабходна запоўніць',
    WRONG_FEEDBACK_EMAIL: 'Некарэктны email',
    YEAR: 'Год',
    WRONG_STATISTICS:
      'Выкарыстоўвайце іншы тып візуалізацыі (гістаграмы, табліцы)',
    DIS_STAT_CITIES_TL: 'Неабходна выбраць не больш за адну вобласць',
    DIS_STAT_VC_TL: 'Неабходна выбраць не больш за адзін раён',
    DIS_STAT_LAYER_TL: "Неабходна выбраць некалькі аб'ектаў АТА",
    UNIT_NAME: 'Адзінка вымярэння',
    DYNAMIC_SERIES: 'Дынамічны рад',
    METADATA: 'Метаданыя',
    EMPTY_STATISTICS_DATA:
      'Па выбраных параметрах даныя адсутнічаюць, абярыце больш буйны (высокі) узровень адміністрацыйна-тэрытарыяльнага дзялення',
  },
};
